/* Sea Moss gallery. Product forms and FAQ details retain native browser behavior. */
(function () {
  'use strict';
  function boot(scope) {
    scope.querySelectorAll('.fsm-gallery').forEach(function (gallery) {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      var slides = Array.from(gallery.querySelectorAll('.fsm-gallery-slide'));
      var thumbs = Array.from(gallery.querySelectorAll('.fsm-thumb'));
      var active = 0;
      var finishTransition = null;
      function select(index) {
        if (finishTransition) finishTransition();
        var previous = active;
        active = (index + slides.length) % slides.length;
        slides.forEach(function (slide, i) { slide.hidden = i !== active; });
        thumbs.forEach(function (thumb, i) { thumb.setAttribute('aria-pressed', String(i === active)); });
        if (previous === active || !slides[active].animate ||
            window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var outgoing = slides[previous];
        var incoming = slides[active];
        var direction = index > previous ? 1 : -1;
        outgoing.hidden = false;
        outgoing.setAttribute('aria-hidden', 'true');
        var options = { duration: 280, easing: 'cubic-bezier(.25,.1,.25,1)', fill: 'both' };
        var exit = outgoing.animate([
          { transform: 'translateX(0)' },
          { transform: 'translateX(' + (-direction * 100) + '%)' }
        ], options);
        var enter = incoming.animate([
          { transform: 'translateX(' + (direction * 100) + '%)' },
          { transform: 'translateX(0)' }
        ], options);
        function finish() {
          if (finishTransition !== finish) return;
          finishTransition = null;
          outgoing.hidden = true;
          outgoing.removeAttribute('aria-hidden');
          exit.cancel();
          enter.cancel();
        }
        finishTransition = finish;
        enter.onfinish = finish;
      }
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { select(i); });
        thumb.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          select(active + (event.key === 'ArrowRight' ? 1 : -1));
          thumbs[active].focus();
        });
      });
      var gesture = null;
      var stage = gallery.querySelector('.fsm-gallery-stage');
      function resetGesture() { gesture = null; }
      stage.addEventListener('touchstart', function (event) {
        if (event.touches.length !== 1) { resetGesture(); return; }
        var touch = event.touches[0];
        gesture = { id: touch.identifier, x: touch.clientX, y: touch.clientY };
      }, { passive: true });
      stage.addEventListener('touchmove', function (event) {
        if (!gesture) return;
        if (event.touches.length !== 1) { resetGesture(); return; }
        var touch = event.touches[0];
        if (touch.identifier !== gesture.id) { resetGesture(); return; }
        var dx = Math.abs(touch.clientX - gesture.x);
        var dy = Math.abs(touch.clientY - gesture.y);
        // A page scroll must never become a gallery swipe later in the gesture.
        if (dy > 12 && dy >= dx) resetGesture();
      }, { passive: true });
      stage.addEventListener('touchcancel', resetGesture, { passive: true });
      stage.addEventListener('touchend', function (event) {
        if (!gesture) return;
        var start = gesture;
        resetGesture();
        if (event.touches.length) return;
        var touch = Array.from(event.changedTouches).find(function (item) {
          return item.identifier === start.id;
        });
        if (!touch) return;
        var dx = touch.clientX - start.x;
        var dy = touch.clientY - start.y;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          select(active + (dx < 0 ? 1 : -1));
        }
      }, { passive: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();



/* ---- offer ladder: drives the real cart quantity, yields to Kaching ---- */
(function () {
  'use strict';

  function appsHaveRendered(scope) {
    // Kaching injects its own selector into the @app block; until it is
    // configured the block is present but empty, so measure real content.
    var blocks = scope.querySelectorAll('.fsm-app-block');
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].getBoundingClientRect().height > 40) return true;
    }
    return false;
  }

  function bind(ladder) {
    if (ladder.__avnBound) return;
    ladder.__avnBound = true;

    var form = document.querySelector('.fsm-product-form');
    var qty = form && form.querySelector('input[name="quantity"]');
    var tiers = Array.prototype.slice.call(ladder.querySelectorAll('[data-avn-tier]'));

    function select(n) {
      ladder.setAttribute('data-avn-sel', String(n));
      if (qty) qty.value = String(n);
      tiers.forEach(function (t) {
        t.setAttribute('aria-pressed', t.getAttribute('data-avn-tier') === String(n) ? 'true' : 'false');
      });
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        select(parseInt(t.getAttribute('data-avn-tier'), 10) || 1);
      });
    });

    select(parseInt(ladder.getAttribute('data-avn-sel'), 10) || 1);
  }

  function boot(scope) {
    scope = scope || document;
    var ladder = scope.querySelector('[data-avn-ladder]') || document.querySelector('[data-avn-ladder]');
    if (!ladder) return;

    // Kaching may mount late; re-check for a few seconds before settling.
    var tries = 0;
    (function settle() {
      if (appsHaveRendered(document)) {
        ladder.hidden = true;
        var q = document.querySelector('.fsm-product-form input[name="quantity"]');
        if (q) q.value = '1';
        return;
      }
      ladder.hidden = false;
      bind(ladder);
      if (++tries < 12) setTimeout(settle, 500);
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
